export function readCookie(name) {
    if (typeof document === 'undefined')
        return null;
    const cookie = document.cookie;
    if (!cookie)
        return null;
    const parts = cookie.split(';');
    let value = null;
    for (const part of parts) {
        const [key, ...rest] = part.split('=');
        if (key?.trim() === name) {
            const rawValue = rest.join('=');
            let decodedValue = rawValue;
            try {
                decodedValue = decodeURIComponent(rawValue);
            }
            catch {
                decodedValue = rawValue;
            }
            if (decodedValue.trim()) {
                value = decodedValue;
            }
        }
    }
    return value;
}
export function readResponseHeader(headers, name) {
    if (!headers)
        return null;
    const lower = name.toLowerCase();
    if (typeof headers.get === 'function') {
        const value = headers.get(name);
        return typeof value === 'string' && value.trim() ? value.trim() : null;
    }
    const record = headers;
    const value = record[name] ??
        record[lower] ??
        Object.entries(record).find(([key]) => key.toLowerCase() === lower)?.[1];
    return typeof value === 'string' && value.trim() ? value.trim() : null;
}
//# sourceMappingURL=csrf-token.js.map